module.exports = __webpack_public_path__ + "img/golem.bedde6b3.png";